import { IUserProfile } from "@/interfaces";
import { Company, CompanyReports } from "@/store/admin";

export class AdminReportData {
    // クラスのメソッド(関数)に型宣言
    public getAdminReports(): CompanyReports[] {
        let date = new Date();
        let company1: Company = {
            id: 0,
            name: "株式会社CFOAi",
            created_at: date
        }
        let company2: Company = {
            id: 1,
            name: "株式会社XXXXXXXXXXXXXXXXXXX",
            created_at: date
        }

        let companyReports: CompanyReports[] = [
            {
                company: company1,
                reports: [{
                    id: 1,
                    company_id: company1.id,
                    created_at: new Date('2022/5/10'),
                    created_by: 0,
                    updated_at: date,
                    updated_by: 0,
                    result_uploaded: true,
                    result_completed_at: null,
                    reenter_request: false,
                },
                {
                    id: 2,
                    company_id: company1.id,
                    created_at: new Date('2022/5/10'),
                    created_by: 0,
                    updated_at: date,
                    updated_by: 0,
                    result_uploaded: true,
                    result_completed_at: new Date('2022/6/25'),
                    reenter_request: false,
                }],
                report_count: 2,
            },
            {
                company: company2,
                reports: [{
                    id: 3,
                    company_id: company2.id,
                    created_at: new Date('2022/5/10'),
                    created_by: 0,
                    updated_at: date,
                    updated_by: 0,
                    result_uploaded: false,
                    result_completed_at: new Date('2022/7/10'),
                    reenter_request: true,
                },
                {
                    id: 4,
                    company_id: company2.id,
                    created_at: new Date('2022/5/10'),
                    created_by: 0,
                    updated_at: date,
                    updated_by: 0,
                    result_uploaded: true,
                    result_completed_at: new Date('2022/6/25'),
                    reenter_request: false,
                }],
                report_count: 2,
            },
        ]
        return companyReports;
    }

    public getAdminUsers(): IUserProfile[] {
        let date = new Date();
        return [{
            id: 0,
            company_id: 0,
            first_name: "太郎",
            last_name: "テスト",
            email: "test@gmail.com",
            is_active: true,
            is_superuser: false,
            setup_completed_at: date,
        }]
    }
}